module.exports = __webpack_public_path__ + "media/flags/gh-51180bec.svg";